















import { Component, Prop, Vue } from "vue-property-decorator";
import { CourseList } from "./courseList";
import CzCard from "../cz/CzCard.vue";
import CzCover from "../cz/CzCover.vue";
import CzChip from "../cz/CzChip.vue";
import CzIcon from "../cz/CzIcon.vue";
import CzTitle from "../cz/CzTitle.vue";

// A course: big cover (poster, YouTube thumbnail or its name) with the play mark, lessons and what it offers.
@Component({ components: { CzCard, CzCover, CzChip, CzIcon, CzTitle } })
export default class CourseCard extends Vue {
  @Prop({ type: Object, required: true }) course!: any;

  get cover(): string {
    return CourseList.cover(this.course);
  }

  get facts(): string {
    return CourseList.facts((key) => this.$t(key).toString(), this.course);
  }

  get progress(): string {
    return CourseList.progress((key) => this.$t(key).toString(), this.course);
  }
}
